import date from 'date-and-time';

const DATE_FORMAT = 'D.M.YYYY HH:mm';

export const getDates = (dateStart?: string, dateEnd?: string): string => {
    if (dateStart) {
        const dateFrom: string = date.format(new Date(dateStart), DATE_FORMAT);
        if (dateEnd) {
            return dateFrom + ` - ${date.format(new Date(dateEnd as string), DATE_FORMAT)}`;
        }
        return dateFrom;
    }
    return ' - ';
};
